jQuery(window).on 'resize', ->
  if jQuery('.__chart_resize').length > 0
    allCharts = jQuery('.__chart_resize')
    i = 0
    while i < allCharts.length
      $item = jQuery(allCharts[i])
      if $item.attr('_echarts_instance_')
        echarts.getInstanceById($item.attr('_echarts_instance_')).resize()
      i++
  return

jQuery(document).ready ($) ->
  chartInstruments = setSwiper '___chart-instruments', 5, 0, 5, false, false, undefined, {
    0: {
      slidesPerView: 2,
    },
    500: {
      slidesPerView: 4,
    },
    650: {
      slidesPerView: 5,
    }
  }

  chartInstruments.on 'click', ->
    $('.___chart-instruments .chart-instrument').removeClass('active')
    symbol_id = $(chartInstruments.clickedSlide).data('active-instrument-id')
    $(chartInstruments.clickedSlide).addClass('active')
    updateChart(symbol_id, true)

  # load chart with first active instrument
  symbol_id = jQuery('.____active-chart-instrument____').data('active-instrument-id')
  if jQuery('#chart-instrument-data').length > 0
    updateChart(symbol_id)
  if jQuery('#chart-blog-instrument-data').length > 0
    updateBlogChart(symbol_id)


  return

updateBlogChart = (symbol_id) ->
  jQuery.ajax(
    url: '/wp-content/themes/varianse/inc/chart-blog.php'
    type: 'POST'
    data: {'chart': true, 'symbol_id': symbol_id}).done (data) ->
      json = jQuery.parseJSON(data)

      prices = json['prices'].sort (a, b) ->
        keyA = new Date(a.date_create)
        keyB = new Date(b.date_create)
        # Compare the 2 dates
        if keyA < keyB
          return -1
        if keyA > keyB
          return 1
        0

      ChartInitialize(prices, 'chart-blog-instrument-data')
      if parseFloat(json['spread_percent']) > 0
        jQuery('.___control_spread_img').html('<img src="/wp-content/themes/varianse/static/images/icons/spread-up.svg" class="spread-direction" />')
        jQuery('.___spread_real_time_percent').html('+' + json['spread_percent'])
      else
        jQuery('.___control_spread_img').html('<img src="/wp-content/themes/varianse/static/images/icons/spread-down.svg" class="spread-direction" />')
        jQuery('.___spread_real_time_percent').html(json['spread_percent'])

      return
  return

updateChart = (symbol_id, reset) ->
  jQuery.ajax(
    url: '/wp-content/themes/varianse/inc/chart.php'
    type: 'POST'
    data: {'chart': true, 'symbol_id': symbol_id}).done (data) ->
      json = jQuery.parseJSON(data)

      prices = json['prices'].sort (a, b) ->
        keyA = new Date(a.date_create)
        keyB = new Date(b.date_create)
        # Compare the 2 dates
        if keyA < keyB
          return -1
        if keyA > keyB
          return 1
        0

      jQuery('.___control-html').html(json['symbol'])
      jQuery('.___control_outlook').html(json['outlook'])
      jQuery('.___control_outlook .chart-bar').addClass('animated')
      if reset
        jQuery('.__chart_control').html('').append('<div id="chart-instrument-data" class="__chart_resize"></div>')

      ChartInitialize(prices, 'chart-instrument-data')
      return
  return

prepareXKeys = (data) ->
  return data.map((x) ->
    return x.date_create
  )

maxValue = (list) ->
  return Math.max.apply(Math, list)

addExtraPercentToValue = (value) ->
  currentValue = parseFloat(value)
  percentToGet = 10
  calcAmount = (percentToGet / 100) * parseFloat(value)
  newPrice = currentValue + calcAmount

  return newPrice

ChartInitialize = (data, name) ->
  chart = echarts.init(document.getElementById(name))

  options = {
    title: {
      left: 'center'
      text: ''
      show: false
    },
    legend: {
      show: false
      textStyle: {
        color: '#D3F2F2'
        fontSize: '12px'
      }
    },
    grid: {
      left: 5
      top: 75
      right: 5
      bottom: 10
    },
    xAxis: {

      type: 'category'
      boundaryGap: false
      data: prepareXKeys(data)
      splitLine: false
      show: false
      scale: false
      axisPointer: {
        lineStyle: {
          color: '#D3F2F2'
          type: 'dashed' # 'solid', 'dashed', 'dotted'
        }
      }
    },
    yAxis: {
      boundaryGap: [0, '15%']
      type: 'value'
      splitLine: false
      scale: true
      show: false
    },
    responsive: true
    tooltip:
      trigger: 'axis' # 'axis', 'item'
      show: true
      backgroundColor: '#473d2e'
      textStyle: {
        fontSize: 12
      }
    toolbox:
      feature:
        dataZoom: {
          yAxisIndex: 'none'
        }
        restore: {}
        saveAsImage: {}
      show: false
    series: [{
      name: ''
      type: 'line'
      symbol: 'none'
      smooth: true
      itemStyle: {
        color: '#D3F2F2'
      }
      lineStyle: {
        type: 'solid' # 'solid', 'dashed', 'dotted'
        width: 1.5
      }
      areaStyle: {
        color: {
          type: 'linear' # 'linear', 'radial'
          x: 0
          y: 0
          x2: 0
          y2: 1
          colorStops: [{
            offset: 0, color: '#D3F2F2'
          }, {
            offset: 1, color: '#D3F2F2'
          }],
          globalCoord: false
        }
      },
      data: data.map((x) -> parseFloat(x.ask))
    },{
      name: '2'
      type: 'line'
      smooth: true
      tooltip: {
        show: false
      }
      symbolSize: 7
      symbol: 'circle'
      lineStyle: {
        type: 'solid' # 'solid', 'dashed', 'dotted'
        width: 1
        color: '#3CC7C7'
      }
      itemStyle: {
        color: '#3CC7C7',
        borderColor: '#3CC7C7',

      }
      data: data.map((x) ->  parseFloat(x.ask))
    }
    ],
  }
  return chart.setOption(options)